import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PROJECT_MANAGEMENT_URL } from '@insite-store360/shared';
import { Observable, catchError } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class AdjustAwardedLeadsService {
  private readonly URL_PATH = `${PROJECT_MANAGEMENT_URL}/adjust-awarded-leads`;

  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService
  ) { }

  /**
   * Get all adjust awarded leads data with pagination, search, and filters
   */
  public getAllLeads(
    pageIndex?: number,
    pageSize?: number,
    searchFilter?: string,
    countryIds?: number[],
    customerIds?: number[],
    projectTypeIds?: number[],
    probabilityIds?: number[],
    createdById?: number,
    salesPersonIds?: number[],
    targetCurrency?: string,
    yearIds?: number[],
    monthIds?: number[],
    deliveryYearIds?: number[]
  ): Observable<{ 
    data: any[]; 
    paginatorValue: { totalData: number; totalCount: number } 
  }> {
    let params = new HttpParams();
    if (pageIndex !== undefined && pageIndex !== null) {
      params = params.set('pageIndex', pageIndex.toString());
    }
    if (pageSize !== undefined && pageSize !== null) {
      params = params.set('pageSize', pageSize.toString());
    }
    if (searchFilter && searchFilter.trim() !== '') {
      params = params.set('searchFilter', searchFilter.trim());
    }
    if (countryIds && countryIds.length > 0) {
      countryIds.forEach(id => {
        params = params.append('countryIds', id.toString());
      });
    }
    if (customerIds && customerIds.length > 0) {
      customerIds.forEach(id => {
        params = params.append('customerIds', id.toString());
      });
    }
    if (projectTypeIds && projectTypeIds.length > 0) {
      projectTypeIds.forEach(id => {
        params = params.append('projectTypeIds', id.toString());
      });
    }
    if (probabilityIds && probabilityIds.length > 0) {
      probabilityIds.forEach(id => {
        params = params.append('probabilityIds', id.toString());
      });
    }
    if (createdById !== undefined && createdById !== null) {
      params = params.set('createdById', createdById.toString());
    }
    if (salesPersonIds && salesPersonIds.length > 0) {
      salesPersonIds.forEach(id => {
        params = params.append('salesPersonIds', id.toString());
      });
    }
    if (targetCurrency) {
      params = params.set('targetCurrency', targetCurrency);
    }
    if (yearIds && yearIds.length > 0) {
      yearIds.forEach(id => {
        params = params.append('yearIds', id.toString());
      });
    }
    if (monthIds && monthIds.length > 0) {
      monthIds.forEach(id => {
        params = params.append('monthIds', id.toString());
      });
    }
    if (deliveryYearIds && deliveryYearIds.length > 0) {
      deliveryYearIds.forEach(id => {
        params = params.append('deliveryYearIds', id.toString());
      });
    }
    return this.http
      .get<{ 
        data: any[]; 
        paginatorValue: { totalData: number; totalCount: number } 
      }>(`${this.URL_PATH}/getAll`, { params })
      .pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get lead details and schedules by leadId
   */
  public getLeadDetails(leadId: string): Observable<any> {
    return this.http
      .get<any>(`${this.URL_PATH}/getById/${leadId}`)
      .pipe(catchError(this.errorHandler.handleError));
  }
}
